<script lang="ts">
</script>

<div class="flex flex-col justify-items-center items-center mx-auto">
  <div class="shadow rounded bg-gray-50 w-11/12 content-center p-1">
    <div class="flex-1 m-4">
      <div class="inline-flex justify-items-center items-center min-w-full">
        <div class="mb:font-sm w-full">
          <p>■注意事項</p>
          <ul class="list-disc ml-4">
            <li>
              <p>本サービスのご利用いただいている電話番号は番号ポータビリティの手筒きはできません</p>
            </li>
            <li>
              <p>
                でんわの利用の際に使用している専用のターミナルアダプタ等については、<span class="warning"
                  >解約月翌月20日必着</span
                >でご返却いただく必要があります。
              </p>
              <p>
                期日までの返却が確認できない場合、<span class="warning">弁済費(21,000円)</span
                >が必要となりますのでご注意ください
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="postcss">
  p {
    @apply text-sm tracking-normal mb-1;
  }
  p > span.warning {
    @apply font-semibold text-red-400;
  }
</style>
